import { View } from "../../uiPatterns/mvvm/view";
import { ViewModel } from "../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../bridges/htmlBridge";
import { BindingPrototype } from "./bindingPrototype";

class HtmlBridgeCreationResult{
    constructor() {
    }

    static create(owner:View<ViewModel>,bridge:HtmlBridge):HtmlBridgeCreationResult {
        let result = new HtmlBridgeCreationResult();
        result.bridge = bridge;
        result.owner = owner;
        return result;
    }
    bridge:HtmlBridge;
    owner:View<ViewModel>
}
abstract class HtmlBridgePrototype{
    public node:Node;
    public binding:BindingPrototype;

    create(view:View<ViewModel>,node:Node):HtmlBridge{
        let realNode = (<any>node).placeHolderFor;
        if(realNode==null)
            realNode = node;
        let result = this.createInternal(view,realNode);
        view.htmlBridges.push(result);
        return result;
    }
    abstract createInternal(view:View<ViewModel>,node:Node): HtmlBridge;

}

export {HtmlBridgePrototype,HtmlBridgeCreationResult}